<app-my-json-ld [itemLD]="json1"></app-my-json-ld>
<!-- <app-subnav [pageType]="'offline-center'"></app-subnav> -->

<app-header [number]="'tel:+91 9058019023'" [url]="'Agra'" [pageType]="'offline-center'"></app-header>


<div id="cat-journey">
  <app-cat-journey [pageType]="'Agra'"></app-cat-journey>
</div>

<!-- <div class="video-sec">
  <div class="container">
      <div class="row justify-content-center">
          <div class="col-md-9">
              <h2>Why iQuanta?</h2>
              <div class="video-card">
                  <iframe title="vimeo-player" src="https://www.youtube.com/embed/W9rnh1HsOZo?autoplay=1&mute=1"
                      width="100%" frameborder="0" allowfullscreen></iframe>
              </div>
          </div>
      </div>
  </div>
</div> -->

<div class="result-banner mobile-none">
  <div class="container">
    <div class="img">
      <img src="https://media.iquanta.in/ui_images/home-image/results-2024.webp" alt="">
      <button mat-raised-button [routerLink]="'/results'">Check Results</button>
    </div>
  </div>
</div>


<div class="result-banner desk-none">
  <div class="container">
    <div class="img">
      <img src="https://media.iquanta.in/ui_images/new-home/result-banner-mob.jpg" alt="">
      <button mat-raised-button [routerLink]="'/results'">Check Results</button>
    </div>
  </div>
</div>

<div class="Sessions ">
  <div class="container">
  

  <div class="texthead">
    <h6>iQuanta CAT 2024 Topper’s Feedback</h6>
      </div>


  

  <div class="">

    <ngx-slick-carousel class="carousel slid_carousel1" #slickModal="slick-carousel" [config]="slideConfig3"
      (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
      (beforeChange)="beforeChange($event)">
      <div ngxSlickItem *ngFor="let slide of toppers2024; let i = index" class="slide card-container1">
        <div class="card">
          <img  [src]="slide" alt="..." class="img-fluid">
          </div>
      </div>
    </ngx-slick-carousel>
  </div>

</div>
</div>

<div class="details">
  <div id="success-stories">
    <div class="Success-Stories">
      <div class="container">
        <div class="head">
          <h2>CAT <span>Success Stories</span> & Feedback</h2>
          <h6 class="desktop_none">All India CAT Toppers</h6>
        </div>
        <div class="gif_img_section">
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <div class="video-card-in mobile-none">
                  <iframe src="https://www.youtube.com/embed/0job0Ca6J5I?autoplay=1&mute=1&loop=1&modestbranding=1&rel=0&fs=0&playlist=0job0Ca6J5I"
                      width="340" height="267" frameborder="0" webkitallowfullscreen mozallowfullscreen
                      allowfullscreen allowfullscreen="true" allow="autoplay" data-ready="true"></iframe>
               </div>
               <div class="video-card-in desk-none">
                  <iframe src="https://www.youtube.com/embed/0job0Ca6J5I?autoplay=1&mute=1&loop=1&modestbranding=1&rel=0&fs=0&playlist=0job0Ca6J5I"
                      width="300" height="180" frameborder="0" webkitallowfullscreen mozallowfullscreen
                      allowfullscreen allowfullscreen="true" allow="autoplay" data-ready="true"></iframe>
               </div>
              </div>
              <!-- <div class="col-md-4">
                <div class="video-card-in mobile-none">
                  <iframe src="https://player.vimeo.com/video/863034379?autoplay=1&muted=1" width="340" height="267"
                  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allowfullscreen="true"
                    allow="autoplay" data-ready="true"></iframe>
                </div>
                <div class="video-card-in desk-none">
                  <iframe src="https://player.vimeo.com/video/863034379?autoplay=1&muted=1" width="300" height="180"
                  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allowfullscreen="true"
                    allow="autoplay" data-ready="true"></iframe>
                </div>
              </div> -->
              <div class="col-md-8">
                <div class="left-topper-images ">
                  <div class="logo-slider toper_img1">
                    <div>
                      <div class="toppers-image-card">
                        <img  (click)="galleryopen(i, successStories)" *ngFor="let img of successStories;let i = index" [src]="img.img"
                          alt="">
                       
                      </div>
                    </div>
                    <div>
                      <div class="toppers-image-card">
                        <img (click)="galleryopen(i, successStories)" *ngFor="let img of successStories;let i = index" [src]="img.img"
                        alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottam-head">
              <h5 class="mobile_none"><span>All India CAT Toppers</span></h5>
              <h5>Students' <span> Genuine Feedback</span> for iQuanta CAT Course</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="topers-feedback">
      <div class="container">
        <div class="head">
          <h2>iQuanta CAT Topper’s Feedback</h2>
        </div>

        <div class="topper-images">
          <div class="logo-slider3">
            <div>
              <div class="feedback-img" *ngFor="let slide of toppersImg;let i = index">
                <img [src]="slide.img" alt="" (click)="galleryopen(i, toppersImg)" >

              </div>
            </div>
            <div>
              <div class="feedback-img" *ngFor="let slide of toppersImg;let i = index">
                <img [src]="slide.img" alt="" (click)="galleryopen(i, toppersImg)" >

              </div>
            </div>
          </div>

        </div>

        <div class="bottem-btns mobile-none">
          <ul>
            <li (click)="gotocourse()"><img src="https://media.iquanta.in/ui_images/full-mocks.png" alt="">iQuanta CAT 2025 Packages</li>
            <li (click)="enquiryForm()" class="btn-1"><img src="https://media.iquanta.in/ui_images/new-home/Counselling.webp" alt="">Free Counselling</li>
            <li (click)="goToSection('toppers-feedback')" class="btn-2"><img src="https://media.iquanta.in/ui_images/trophy.png" alt="">iQuanta CAT Result</li>
          </ul>
        </div>
        <div class="bottem-btns desktop_none">
          <div class="row m-0 p-0">
            <div class="col-md-12">
              <button (click)="gotocourse()" class="" mat-raised-button><img
                  src="https://media.iquanta.in/ui_images/full-mocks.png" alt="">iQuanta CAT
                2025 Packages</button>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col pr-0">
                  <button (click)="enquiryForm()" mat-raised-button class="btn-1"> <img
                      src="https://media.iquanta.in/ui_images/new-home/Counselling.webp"
                      alt="">Free Counselling</button>
                </div>
                <div class="col pl-0">
                  <button (click)="goToSection('toppers-feedback')"  class="btn-2" mat-raised-button><img src="https://media.iquanta.in/ui_images/trophy.png" alt="">iQuanta CAT
                    Result</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="Apprehension">
    <div class="container">
      <div class="head">
        <h2>Apprehension due to Bad Profile or Low %ile?</h2>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="Sessions ">

            <div class="texthead">
              <h6>Low to High %ile</h6>
            </div>


            <div class="desk-none mt-4 mb-4">
              <ul class="row flex-row flex-nowrap othermba-exam">
                <li class="col-12 px-md-2 px-2" *ngFor="let session of Sessionslist1; let i = index">
                  <div class="session-card">
                    <div class="img-div">
                      <img src="{{session.img}}" alt="" (click)="galleryopen(i, Sessionslist1)">
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="mobile-none">

              <ngx-slick-carousel class="carousel slid_carousel1" #slickModal="slick-carousel" [config]="slideConfig"
                (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
                (beforeChange)="beforeChange($event)">
                <div ngxSlickItem *ngFor="let session of Sessionslist1; let i = index" class="slide card-container1">
                  <div class="card">
                    <img (click)="galleryopen(i, Sessionslist1)" [src]="session.img" alt="..." class="img-fluid">
                    </div>
                </div>
              </ngx-slick-carousel>
            </div>

          </div>
        </div>
        <div class="col-md-6">
          <div class="Sessions ">

            <div class="texthead">
              <h6>Bad Acads</h6>
            </div>


            <div class="desk-none mt-4">
              <ul class="row  othermba-exam ">
                <li class="col-md-12 px-md-2 px-2" >
                  <div class="session-card">
                    <div class="img-div">
                      <img src="https://media.iquanta.in/ui_images/cat-2024-new/ayushviedo.jpg" alt="">

                    </div>

                  </div>
                </li>
                <li class="col-md-12 px-md-2 px-2" >
                  <div class="session-card">
                    <div class="img-div" (click)="singleGallery()">
                      <img src="https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_190781004_484934279394175_8324459811870473182_n+(1).jpg" alt="">

                    </div>

                  </div>
                </li>
              </ul>
            </div>

            <div class="mobile-none">

              <ngx-slick-carousel class="carousel slid_carousel1" #slickModal="slick-carousel" [config]="slideConfig"
                (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
                (beforeChange)="beforeChange($event)">
                <div ngxSlickItem  class="slide card-container1">
                  <div class="card" (click)="playVideo1()">
                    <img src="https://media.iquanta.in/ui_images/cat-2024-new/ayushviedo.jpg" alt="..." class="img-fluid">
                  </div>
                </div>
                 <div ngxSlickItem  class="slide card-container1">
                  <div class="card" (click)="singleGallery()">
                    <img src="https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_190781004_484934279394175_8324459811870473182_n+(1).jpg" alt="..." class="img-fluid">
                  </div>
                </div>
              </ngx-slick-carousel>
            </div>


            <!-- <div class="view-btn desk-none">
                        <button mat-raised-button> <img
                                src="https://media.iquanta.in/ui_images/star.png" alt=""> View All
                            Features</button>
                    </div> -->

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="all_cources" id="courses">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionheader">
                    <h2 class="siteheading">Courses</h2>

                </div>

            </div>

            <div class="col-md-12 tab_none_course">
                <div class="course_grid">

                    <div class="row justify-content-center">
                        <div class="col-md-4" *ngFor="let course of coursesArray" id="{{ 'course' + course.order  }}">
                            <app-course-card [course]="course" [pageName]="'patna'"></app-course-card>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<div class="content">
  <div class="container">
    <h2>Best CAT Coaching in Agra</h2>
    <p>
    You have found the best CAT coaching in Agra if you are an aspirant student hoping to pass any of the MBA exams, including CAT, XAT, IIFT, NMAT, SNAP, TISSNET, CMAT, MAT, ATMA, and MH-CET. You can receive exceptional instruction from iQuanta, the top CAT coaching in Agra, which has some of the best mentors and trainers in the business. Year after year, they plan and prepare so that these students can get into a reputable business school. With peer-to-peer learning, high-quality information, 24/7 doubt-solving, relevant content, CAT tutoring available both online and offline, and much more, iQuanta is a titan in this quickly changing educational landscape.
    </p>
    
    <h2>iQuanta’s Presence in the Education Industry</h2>
    <p>
    What other institutes receive in fifteen years, iQuanta has delivered in five. Additionally, they have received hundreds of IIM conversions and over 40,000 IIM calls in this brief time frame. What was once a newcomer to this field is now Lucknow's top CAT coaching provider. Beyond only fulfilling students' dreams, it has planted a priceless seed: trust. One of the biggest CAT preparation organizations is iQuanta, which has over 360,000 candidates worldwide.
    </p>
    
    <h3>Founder and Vision</h3>
    <p>
    Indrajeet Singh, the founder, started this group with a view to support fellow aspirants through his special skills in Mathematics and Logical Reasoning. As news spread, iQuanta achieved results in four years which seasoned professionals in the field took fifteen years to achieve. The consistent success that iQuanta demonstrated every year outlined its commitment to long term growth and expansion. Currently, it offers paid packages for different examinations like CAT, XAT, NMAT, and SNAP, having plans to broaden its offerings in the near future.
    </p>
    
    <h2>iQuanta’s Faculties at Agra Center</h2>
    <p>
    iQuanta is pleased to have a group of highly skilled and experienced teachers at Agra Center that are committed to helping students reach their academic objectives and realize their full potential. Every student at the Agra center of iQuanta receives top-notch instruction and support for the CAT and other competitive tests because of individualized attention, innovative teaching methods, and a dedication to perfection.
    </p>
    
    <h2>iQuanta’s Offerings at Agra Center</h2>
    <p>
    One of the top CAT tutoring services in Agra is iQuanta. It is well known for its methodical, comprehensive methodology, which it employs to deliver first-rate classroom instruction for management exams including the CAT, XAT, and OMETs. With a primary focus on students in their 12th grade, its knowledge is also offered for other significant tests such as IPMAT, CUET UG, and CLAT. The iQuanta teaching staff places a strong emphasis on providing students with the right foundation so they can learn subjects with the most effort possible. Students that have this kind of awareness are more likely to receive high grades. Their teaching staff has established themselves as the go-to institution for any student hoping to achieve the highest score on any competitive exam thanks to their focused approach and success-driven technique.
    </p>
    <h2>Best CAT Coaching in Agra</h2>
    <p>
    You have found the best CAT coaching in Agra if you are an aspirant student hoping to pass any of the MBA exams, including CAT, XAT, IIFT, NMAT, SNAP, TISSNET, CMAT, MAT, ATMA, and MH-CET. You can receive exceptional instruction from iQuanta, the top CAT coaching in Agra, which has some of the best mentors and trainers in the business. Year after year, they plan and prepare so that these students can get into a reputable business school. With peer-to-peer learning, high-quality information, 24/7 doubt-solving, relevant content, CAT tutoring available both online and offline, and much more, iQuanta is a titan in this quickly changing educational landscape.
    </p>
    
    <h2>iQuanta’s Presence in the Education Industry</h2>
    <p>
    What other institutes receive in fifteen years, iQuanta has delivered in five. Additionally, they have received hundreds of IIM conversions and over 40,000 IIM calls in this brief time frame. What was once a newcomer to this field is now Lucknow's top CAT coaching provider. Beyond only fulfilling students' dreams, it has planted a priceless seed: trust. One of the biggest CAT preparation organizations is iQuanta, which has over 360,000 candidates worldwide.
    </p>
    
    <h3>Founder and Vision</h3>
    <p>
    Indrajeet Singh, the founder, started this group with a view to support fellow aspirants through his special skills in Mathematics and Logical Reasoning. As news spread, iQuanta achieved results in four years which seasoned professionals in the field took fifteen years to achieve. The consistent success that iQuanta demonstrated every year outlined its commitment to long term growth and expansion. Currently, it offers paid packages for different examinations like CAT, XAT, NMAT, and SNAP, having plans to broaden its offerings in the near future.
    </p>
    
    <h2>iQuanta’s Faculties at Agra Center</h2>
    <p>
    iQuanta is pleased to have a group of highly skilled and experienced teachers at Agra Center that are committed to helping students reach their academic objectives and realize their full potential. Every student at the Agra center of iQuanta receives top-notch instruction and support for the CAT and other competitive tests because of individualized attention, innovative teaching methods, and a dedication to perfection.
    </p>
    
    <h2>iQuanta’s Offerings at Agra Center</h2>
    <p>
    One of the top CAT tutoring services in Agra is iQuanta. It is well known for its methodical, comprehensive methodology, which it employs to deliver first-rate classroom instruction for management exams including the CAT, XAT, and OMETs. With a primary focus on students in their 12th grade, its knowledge is also offered for other significant tests such as IPMAT, CUET UG, and CLAT. The iQuanta teaching staff places a strong emphasis on providing students with the right foundation so they can learn subjects with the most effort possible. Students that have this kind of awareness are more likely to receive high grades. Their teaching staff has established themselves as the go-to institution for any student hoping to achieve the highest score on any competitive exam thanks to their focused approach and success-driven technique.
    </p>
        
  </div>
</div>



  <div id="syllabus">
    <app-everything-about-cat (gocourses)="gotocourses($event)" [selectedIndex]="selectedIndex" [pageType]="'cat'"></app-everything-about-cat>
    <!-- <div class="know-all">
      <div class="container">
        <div class="know-card">
          <div class="row">
            <div class="col-md-5">
              <div class="card-text">
                <h2>Know All About <br>
                  Top 100 B-Schools!</h2>

                <a href="#">Check Now</a>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card-text about-card">
                <h6>Know About</h6>
                <ul>
                  <li>1. Average Package</li>
                  <li> 2. Highest Package</li>
                  <li> 3. Required Percentile </li>
                  <li> 4. Exam Details</li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <div class="predict-btn">
                <h6>Predict Your
                  B-School Now</h6>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->

    <div class="how-began-preparation">
      <div class="container">

        <div class="col-md-12">
          <div class="sec-title">
            <h2>CAT Syllabus</h2>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="tab-content">
              <mat-tab-group mat-align-tabs="center">
                <mat-tab>
                  <ng-template mat-tab-label>
                    <!-- <i class="bi bi-browser-chrome"></i> -->
                    QUANT
                  </ng-template>
                  <div class="tab-content-in">
                    <div class="img desk-none">
                      <img src="https://media.iquanta.in/ui_images/Quant-syllabus-weightage.jpg"
                        alt="">
                    </div>
                    <div class="img py-4 mobile-none ">
                      <img
                        src="https://media.iquanta.in/ui_images/web-quant-syllabus-weightage.jpg"
                        alt="">
                    </div>

                  </div>


                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <!-- <i class="bi bi-browser-edge"></i> -->
                    LRDI
                  </ng-template>
                  <div class="tab-content-in">
                    <div class="img py-4 mobile-none">
                      <img
                        src="https://media.iquanta.in/ui_images/web-LRDI-syllabus-weightage.jpg"
                        alt="">
                    </div>
                    <div class="img desk-none">
                      <img src="https://media.iquanta.in/ui_images/LRDI-syllabus-weightage.jpg"
                        alt="">
                    </div>

                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <!-- <i class="bi bi-browser-firefox"></i> -->
                    VARC
                  </ng-template>
                  <div class="tab-content-in">
                    <div class="img py-4 mobile-none">
                      <img
                        src="https://media.iquanta.in/ui_images/web-VARC-syllabus-weightage.jpg"
                        alt="">
                    </div>
                    <div class="img desk-none">
                      <img src="https://media.iquanta.in/ui_images/VARC-syllabus-weightage.jpg"
                        alt="">
                    </div>

                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>

          </div>
        </div>
      </div>
    </div>
    <app-score-vs-percentile [pageName]="'home'"></app-score-vs-percentile>
  </div>

  <div id="resources">
    <div class="container">
      <div class="resources mobile-none">
        <div class="row justify-content-center">
          <div class="col-md-9">
            <div class="head">
              <h2>iQuanta‘s CAT Resources</h2>
            </div>
          </div>
        </div>
        <div class="resources-cards">
          <div class="row">
            <div class="col-md-6">
              <div class="paid">
                <div class="sub-head">
                  <h2>paid</h2>
                  <img src="https://media.iquanta.in/ui_images/spark.png" alt="">
                </div>

                <div class="card">
                  <ul>
                    <li>
                      <div class="num">
                        <h6>01</h6>
                      </div>
                      <div class="text">Conceptual live Stream Classes 70+</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>02</h6>
                      </div>
                      <div class="text">Live Application Classes 100+</div>
                    </li>
                    <!-- <li>
                      <div class="num">
                        <h6>03</h6>
                      </div>
                      <div class="text">Conceptual lives Stream Classes 70+</div>
                    </li> -->
                    <li>
                      <div class="num">
                        <h6>03</h6>
                      </div>
                      <div class="text">Mentor Driven Practice session
                        (Weekly 4)</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>04</h6>
                      </div>
                      <div class="text">iQuanta Exclusive Material
                        (Per Topic 50 | Total 5000 Quesions)</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>05</h6>
                      </div>
                      <div class="text">iCAT Mocks: 20 Full | 45 Sectional</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>06</h6>
                      </div>
                      <div class="text">IIM ABC Practice Batch 7500 Qs
                        500 RC SETS | 5OO LRDI SETS | 2500 QA</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>07</h6>
                      </div>
                      <div class="text">CAT Crash Course
                        Rigorous Practice | Shortcuts |
                        Live Marathons</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>08</h6>
                      </div>
                      <div class="text">24*7 Doubt Solving</div>
                    </li>
                    <li>
                      <div class="num">
                        <h6>09</h6>
                      </div>
                      <div class="text">Special Initiatives by Indrajeet Singh
                        iQuanta 250 QA | LRDI 70 by Indra |
                        RC 60 by Indra</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="paid free">
                <div class="sub-head">
                  <h2>free</h2>

                </div>

                <div class="card">
                  <ul>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>01</h6>
                        </div>
                        <div class="text">CAT Past Year Papers</div>
                      </div>
                      <button (click)="gotoLink('https://www.iquanta.in/test/cat-previous-papers')"
                        mat-raised-button>Check Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>02</h6>
                        </div>
                        <div class="text">CAT Sectional Resources</div>
                      </div>
                      <button (click)="gotoLink('https://www.iquanta.in/free-cat-study-material')" mat-raised-button>Check
                        Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>03</h6>
                        </div>
                        <div class="text">CAT Doubt Solving Group</div>
                      </div>
                      <button (click)="gotoLink('https://www.facebook.com/groups/iquantacat')" mat-raised-button>Join
                        Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>04</h6>
                        </div>
                        <div class="text">CAT LRDI Resources</div>
                      </div>
                      <button (click)="gotoLink('https://www.iquanta.in/free-cat-study-material')" mat-raised-button>Check
                        Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>05</h6>
                        </div>
                        <div class="text">Download Formula Book</div>
                      </div>
                      <button
                        (click)="gotoLink('https://media.iquanta.in/ui_images/iQuanta+Quant+Formulae+eBook+.pdf')"
                        mat-raised-button class="download">Download</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>06</h6>
                        </div>
                        <div class="text">Download CAT Brochure</div>
                      </div>
                      <button
                        (click)="gotoLink('https://media.iquanta.in/cat-2025-strategy-syllabus.pdf')"
                        mat-raised-button>Download</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>07</h6>
                        </div>
                        <div class="text">Download MBA Brochure</div>
                      </div>
                      <button
                        (click)="gotoLink('https://media.iquanta.in/ui_images/MBA_BROCHURE.pdf')"
                        mat-raised-button>Download</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>08</h6>
                        </div>
                        <div class="text">CAT Before CAT</div>
                      </div>
                      <button (click)="gotoLink('https://www.iquanta.in/cat-before-cat')" mat-raised-button>Check
                        Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>09</h6>
                        </div>
                        <div class="text">iCAT Mocks</div>
                      </div>
                      <button (click)="gotoLink('https://www.iquanta.in/cat-mock-test')" mat-raised-button
                        class="Attempt">Attempt Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>10</h6>
                        </div>
                        <div class="text">120 QA Qs. Playlist</div>
                      </div>
                      <button
                        (click)="gotoLink('https://www.youtube.com/watch?v=hcnA9i_EzzE&list=PL4YW4OWyzRDQVmPJHJWxg-Mw1LJjgEzHU')"
                        mat-raised-button>Check Now</button>
                    </li>
                    <li class="cd">
                      <div class="points">
                        <div class="num">
                          <h6>11</h6>
                        </div>
                        <div class="text">100 LRDI Qs. Playlist</div>
                      </div>
                      <button (click)="gotoLink('https://youtube.com/playlist?list=PL4YW4OWyzRDS7VhRSNqx42cvvpOp6zg8Z')"
                        mat-raised-button>Check Now</button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="enroll">
                <h2>Everything Included in CAT Full Course
                  just buy IIM ABC as an addon.</h2>
                <div class="btns">
                  <button mat-raised-button (click)="gotocourse()">Enrol Now</button>
                </div>
    
              </div>
            </div>
          </div>
         

        </div>
      </div>
      <div class="resources desktop_none">
        <div class="row justify-content-center">
          <div class="col-md-9">
            <div class="head">
              <h2>iQuanta‘s CAT Resources</h2>
            </div>
          </div>
        </div>
        <div class="resources-cards">
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="pills-home-tab" data-toggle="pill" data-target="#pills-home"
                type="button" role="tab" aria-controls="pills-home" aria-selected="true">Paid
                <img src="https://media.iquanta.in/ui_images/spark.png" alt="">
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link link-two" id="pills-profile-tab" data-toggle="pill" data-target="#pills-profile"
                type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Free</button>
            </li>

          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"
              tabindex="0">
              <div class="card">
                <ul>
                  <li>
                    <div class="num">
                      <h6>01</h6>
                    </div>
                    <div class="text">Conceptual live Stream Classes 70+</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>02</h6>
                    </div>
                    <div class="text">Live Application Classes 100+</div>
                  </li>
                  <!-- <li>
                    <div class="num">
                      <h6>03</h6>
                    </div>
                    <div class="text">Conceptual lives Stream Classes 70+</div>
                  </li> -->
                  <li>
                    <div class="num">
                      <h6>03</h6>
                    </div>
                    <div class="text">Mentor Driven Practice session
                      (Weekly 4)</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>04</h6>
                    </div>
                    <div class="text">iQuanta Exclusive Material
                      (Per Topic 50 | Total 5000 Quesions)</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>05</h6>
                    </div>
                    <div class="text">iCAT Mocks: 20 Full | 45 Sectional</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>06</h6>
                    </div>
                    <div class="text">IIM ABC Practice Batch 7500 Qs
                      500 RC SETS | 5OO LRDI SETS | 2500 QA</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>07</h6>
                    </div>
                    <div class="text">CAT Crash Course
                      Rigorous Practice | Shortcuts |
                      Live Marathons</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>08</h6>
                    </div>
                    <div class="text">24*7 Doubt Solving</div>
                  </li>
                  <li>
                    <div class="num">
                      <h6>09</h6>
                    </div>
                    <div class="text">Special Initiatives by Indrajeet Singh
                      iQuanta 250 QA | LRDI 70 by Indra |
                      RC 60 by Indra</div>
                  </li>
                </ul>
                <div class="enroll-now">
                  <h2>Everything Included in CAT Full Course
                    just buy IIM ABC as an addon.</h2>
                  <div class="btns">
                    <button mat-raised-button (click)="gotocourse()">Enrol Now</button>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
              tabindex="0">
              <div class="card card-two">
                <ul>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>01</h6>
                      </div>
                      <div class="text">CAT Past Year Papers</div>
                    </div>
                    <button mat-raised-button>Check Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>02</h6>
                      </div>
                      <div class="text">CAT Sectional Resources</div>
                    </div>
                    <button mat-raised-button>Check Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>03</h6>
                      </div>
                      <div class="text">CAT Doubt Solving Group</div>
                    </div>
                    <button mat-raised-button>Join Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>04</h6>
                      </div>
                      <div class="text">CAT LRDI Resources</div>
                    </div>
                    <button mat-raised-button>Check Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>05</h6>
                      </div>
                      <div class="text">Download Formula Book</div>
                    </div>
                    <button mat-raised-button class="download">Download</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>06</h6>
                      </div>
                      <div class="text">Download CAT Brochure</div>
                    </div>
                    <button mat-raised-button>Download</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>07</h6>
                      </div>
                      <div class="text">Download MBA Brochure</div>
                    </div>
                    <button mat-raised-button>Download</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>08</h6>
                      </div>
                      <div class="text">CAT Before CAT</div>
                    </div>
                    <button mat-raised-button>Check Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>09</h6>
                      </div>
                      <div class="text">iCAT Mocks</div>
                    </div>
                    <button mat-raised-button class="Attempt">Attempt Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>10</h6>
                      </div>
                      <div class="text">120 QA Qs. Playlist</div>
                    </div>
                    <button mat-raised-button>Check Now</button>
                  </li>
                  <li class="cd">
                    <div class="points">
                      <div class="num">
                        <h6>11</h6>
                      </div>
                      <div class="text">100 LRDI Qs. Playlist</div>
                    </div>
                    <button mat-raised-button>Check Now</button>
                  </li>
                </ul>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>

  </div>
  <!-- <div>
    <app-exclusive-cat></app-exclusive-cat>
  </div> -->
  <div id="toppers-feedback">
    <app-topper-percentile></app-topper-percentile>
    <app-iquanta-toppers-section></app-iquanta-toppers-section>
  </div>

  <div class="address-sec">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <h6>

                    <i class="bi bi-geo-alt"></i>
                    ⁠Hall no 4, 3rd Floor, Raman Tower, Sanjay Place, Agra- 282002

                </h6>


                <h6>

                    <i class="bi bi-telephone"></i>

                    <a href="tel:+91 9058019023">+91  9058019023</a>
                </h6>

            </div>
            <div class="col-md-6">
              <div class="map">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14194.575766103857!2d78.006472!3d27.1989255!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3974776258d17ea3%3A0x6399aaff98db8992!2siQuanta%20Agra%20-%20Best%20CAT%20Coaching%20in%20Agra!5e0!3m2!1sen!2sin!4v1720518129575!5m2!1sen!2sin"  style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
        </div>
    </div>
</div>

</div>

<!-- <div class="overlay" (click)="openStepFour()" *ngIf="stepFourCard">
</div> -->


<div class="footer-sticky-menu">

  <ul class="footer-icon-menu">

    <li>

      <div (click)="goToSection('cat-journey')" class="foot-nav"
        [ngClass]="{'active':activeFooterTab == 'cat-journey' }">
        <img *ngIf="activeFooterTab != 'cat-journey'" src="https://media.iquanta.in/ui_images/route.png" alt="">
        <img *ngIf="activeFooterTab == 'cat-journey'" src="https://media.iquanta.in/ui_images/route.png" alt="">
        <span>CAT 2025 Journey</span>
      </div>

    </li>

    <li>

      <div (click)="goToSection('courses')" class="foot-nav" [ngClass]="{'active':activeFooterTab == 'courses' }">
        <img *ngIf="activeFooterTab != 'courses'"
          src="https://media.iquanta.in/ui_images/cat-course-footer.png" alt="">
        <img *ngIf="activeFooterTab == 'courses'"
          src="https://media.iquanta.in/ui_images/cat-course-footer-active.png" alt="">

        <span>iQuanta CAT Courses </span>
      </div>

    </li>
    
    <li>
      <div (click)="goToSection('syllabus')" class="foot-nav" [ngClass]="{'active':activeFooterTab == 'syllabus' }">
        <img *ngIf="activeFooterTab != 'syllabus'"
          src="https://media.iquanta.in/ui_images/cat-details-footer.png" alt="">
        <img *ngIf="activeFooterTab == 'syllabus'"
          src="https://media.iquanta.in/ui_images/cat-details-footer-active.png" alt="">
        <span>CAT Exam Details</span>
      </div>
    </li>

    <li>
      <div (click)="goToSection('resources')" class="foot-nav" [ngClass]="{'active':activeFooterTab == 'resources' }">
        <img *ngIf="activeFooterTab != 'resources'"
          src="https://media.iquanta.in/ui_images/cat-resources-footer.png" alt="">
        <img *ngIf="activeFooterTab == 'resources'"
          src="https://media.iquanta.in/ui_images/cat-resources-footer-active.png" alt="">
        <span>CAT Resources!</span>
      </div>
    </li>

    <li>
      <div (click)="goToSection('toppers-feedback')" class="foot-nav"
        [ngClass]="{'active':activeFooterTab == 'toppers-feedback' }">
        <img *ngIf="activeFooterTab != 'toppers-feedback'"
          src="https://media.iquanta.in/ui_images/toppers-footer.png" alt="">
        <img *ngIf="activeFooterTab == 'toppers-feedback'"
          src="https://media.iquanta.in/ui_images/toppers-footer-active.png" alt="">
        <span>CAT Toppers & Feedback</span>
      </div>
    </li>
  </ul>
</div>


<div class="Strategy desk-footer-sticky">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="btns">
          <ul>
            <li (click)="goToSection('cat-journey')"><a [ngClass]="{'active':activeFooterTab == 'cat-journey' }">CAT 2025 Journey</a></li>
            <li (click)="goToSection('success-stories')"><a
                [ngClass]="{'active':activeFooterTab == 'success-stories' }">Success Stories & Feedback</a></li>
            <li (click)="goToSection('courses')"><a [ngClass]="{'active':activeFooterTab == 'courses' }">iQuanta CAT Courses</a></li>
            <li (click)="goToSection('syllabus')"><a [ngClass]="{'active':activeFooterTab == 'syllabus' }">CAT Details, Syllabus, Pattern etc</a></li>
            <!-- <li (click)="goToSection('strategy')"><a [ngClass]="{'active':activeFooterTab == 'strategy' }">CAT Strategy</a></li> -->
            <li (click)="goToSection('resources')"><a [ngClass]="{'active':activeFooterTab == 'resources' }">CAT
                Resources</a></li>
            <li (click)="goToSection('toppers-feedback')"><a
                [ngClass]="{'active':activeFooterTab == 'toppers-feedback' }">iQuanta
                Toppers' Result</a></li>
          </ul>
        </div>
      </div>
    </div>

  </div>

</div>